import React, { useState } from 'react';
import Icon from '@/components/AppIcon';
import Button from '@/components/ui/Button';
import Image from '@/components/AppImage';
import dayjs from 'dayjs';

const ListView = ({ n }) => {

return (
<div
className={`p-4 rounded-lg border transition ${
n.isRead
? 'bg-background border-border'
: 'bg-primary/5 border-primary'
}`}
>
<div className="flex justify-between items-start">
<div>
<p className="font-medium">{n.type}</p>
<p className="text-sm text-text-secondary">
{n.title} · {n.company}
</p>
</div>

<span className="text-xs text-text-secondary">
{dayjs(n.when).fromNow()}
</span>
</div>
</div>
);
};

export default ListView;